import React, { Component } from 'react';
import { ButtonGroup, Button, Glyphicon } from 'react-bootstrap';
import { history } from '../../helpers/history';
import EditableTextField from './EditableTextField';
import DangerButton from '../Misc/DangerButton';
import ContractTypeDropdown from './ContractTypeDropdown';
import ToggleSwitch from '../ToggleSwitch';

export default class ThemePackageListRow extends Component {

    handleNameChange = (name) => {
        this.props.onEditName(this.props.id, name, this.props.name);
    }

    handleContractTypeChange = (type) => {
        this.props.onEditType(this.props.id, type, this.props.contractType);
    }

    handleClick = (e) => {
        if (e.target.className === "text-link") history.push(`/dashboard/themes/${this.props.id}`);
    }

    handleDuplicateClick = () => {
        this.props.onDuplicate(this.props.id);
    }

    handleDeleteClick = () => {
        this.props.onDelete(this.props.id);
    }

    handleDefaultUserToggle = (value) => {
        this.props.onToggleDefaultUser(this.props.id, value);
    }

    handleDefaultGuestToggle = (value) => {
        this.props.onToggleDefaultGuest(this.props.id, value);
    }

    handleDefaultPortfolioToggle = (value) => {
        this.props.onToggleDefaultPortfolio(this.props.id, value);
    }

    getOrganizationsLabel() {
        let organizations = this.props.organizations.filter(x => x != "Default" && x != "DefaultForGuest" && x != "DefaultForPortfolio");
        if (!organizations) return "";
        if (organizations.length > 1) return `${organizations[0]}...`;
        else if (organizations.length === 1) return organizations[0];
        else return "";
    }

    render() {
        let isDefaultForUser = this.props.organizations.includes("Default");
        let isDefaultForGuest = this.props.organizations.includes("DefaultForGuest");
        let isDefaultForPortfolio = this.props.organizations.includes("DefaultForPortfolio");
        return (
            <tr id={`row-${this.props.index}`} className="category-row" >
                <td onClick={this.handleClick}>
                    <EditableTextField
                        text={this.props.name}
                        viewProps={{
                            className: 'text-link'
                        }}
                        onChange={this.handleNameChange}
                    />
                </td>
                <td><span><ContractTypeDropdown onChange={this.handleContractTypeChange} type={this.props.contractType} /></span></td>
                <td>{this.getOrganizationsLabel()}</td>
                <td>
                    <div className="toggle-switch-container">
                        <ToggleSwitch initialValue={isDefaultForGuest} onChange={this.handleDefaultGuestToggle} />
                        <ToggleSwitch initialValue={isDefaultForUser} onChange={this.handleDefaultUserToggle} />
                        <ToggleSwitch initialValue={isDefaultForPortfolio} onChange={this.handleDefaultPortfolioToggle} />
                    </div>
                </td>
                <td>
                    <ButtonGroup>
                        <Button onClick={this.handleDuplicateClick}> <Glyphicon glyph="duplicate" /></Button>
                        <DangerButton warningText="Are you sure you want to delete this theme?" onClick={this.handleDeleteClick}><Glyphicon glyph="trash" /></DangerButton>
                    </ButtonGroup>
                </td>
            </tr>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CategoryView/ThemePackageListRow.js